
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { BarChart3, PieChartIcon } from "lucide-react";
import PieChartDisplay from "../charts/PieChartDisplay";
import StackedBarChart from "../charts/StackedBarChart";

interface AfwijkendeOrdersTabProps {
  deviantOrdersData: any[];
  deviantReasonsData: any[];
}

const AfwijkendeOrdersTab: React.FC<AfwijkendeOrdersTabProps> = ({
  deviantOrdersData,
  deviantReasonsData
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Afwijkende orders trend</CardTitle>
            <CardDescription>Verhouding afwijkende en normale orders</CardDescription>
          </div>
          <BarChart3 className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <StackedBarChart
            data={deviantOrdersData}
            nameKey="month"
            keys={[
              { dataKey: "normaal", name: "Normale orders", color: "#34C759" },
              { dataKey: "afwijkend", name: "Afwijkende orders", color: "#FF3B30" }
            ]}
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Redenen voor afwijkingen</CardTitle>
            <CardDescription>Verdeling van afwijkingsredenen</CardDescription>
          </div>
          <PieChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <PieChartDisplay data={deviantReasonsData} />
        </CardContent>
      </Card>
    </div>
  );
};

export default AfwijkendeOrdersTab;
